import LegacyFilterModel, {
  FilterModel,
  LegacySimpleCondition,
} from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import { isCombinedCondition } from "@app/util/viewModel/assert";

const mergeFilterModels = (
  existingFilterModel: LegacyFilterModel,
  newFilterModel: Partial<LegacyFilterModel>
): LegacyFilterModel => {
  const resultingFilterModel: LegacyFilterModel = { ...existingFilterModel };
  Object.keys(newFilterModel).forEach((fieldName) => {
    const condition = newFilterModel[fieldName];
    // TODO: consider changing this logic to the following:
    // - when condition is undefined - ignore it
    // - when condition is null - delete such filter
    // - otherwise, update filter with a new condition
    // The reason for this update is some ambiguity when we deal with undefined values.
    // Does it mean to delete or is it just missing? If we start using null for delete,
    // then logic will be more straightforward.
    // Btw such logic is what AgGrid uses in the filter model updates.
    if (isDefined(condition)) {
      resultingFilterModel[fieldName] = condition;
    } else {
      delete resultingFilterModel[fieldName];
    }
  });
  return resultingFilterModel;
};

export default mergeFilterModels;

export const mergeNewFilterModelsOnRootLevel = (
  existingFilterModel: FilterModel,
  newFilterModel: Partial<LegacyFilterModel>
): FilterModel => {
  const remainingFilterModel = { ...newFilterModel };
  const result = {
    ...existingFilterModel,
    conditions: existingFilterModel.conditions
      .map((condition) => {
        if (isCombinedCondition(condition)) {
          return condition;
        }

        const fieldFilterName = condition.fieldFilterName;
        if (fieldFilterName in newFilterModel) {
          delete remainingFilterModel[fieldFilterName];
          return isDefined(newFilterModel[fieldFilterName])
            ? { ...(newFilterModel[fieldFilterName] as LegacySimpleCondition), fieldFilterName }
            : undefined;
        }
        return condition;
      })
      .filter(isDefined),
  };

  Object.keys(remainingFilterModel).forEach((fieldFilterName) => {
    if (remainingFilterModel[fieldFilterName]) {
      result.conditions.push({
        ...(remainingFilterModel[fieldFilterName] as LegacySimpleCondition),
        fieldFilterName,
      });
    }
  });

  return result;
};
